class Notify {

	constructor() {
		this.initialize();
   	}

	initialize() {
		let remove = $('[data-notify-remove]');

		remove.on('click', function() {
			let el = $(this);
			let notify = el.closest('[data-notify]');

			notify.remove();
		});
   	}
}

new Notify();
